import { SVGProps, Ref, forwardRef } from 'react';

export const MailBrandAltSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M15.012 11.997a3.01 3.01 0 1 1-3.009-3.009 3.013 3.013 0 0 1 3.009 3.009M12.003 2C6.488 2 2 6.488 2 12.003 2 17.52 6.488 22 12.003 22a9.94 9.94 0 0 0 5.635-1.742l.031-.02-1.348-1.566-.024.012a7.95 7.95 0 0 1-4.294 1.26c-4.38 0-7.947-3.566-7.947-7.947S7.622 4.05 12.003 4.05s7.948 3.566 7.948 7.947q0 .855-.189 1.71c-.25 1.035-.971 1.348-1.516 1.305-.546-.044-1.185-.433-1.191-1.386v-1.63a5.063 5.063 0 0 0-5.058-5.057 5.064 5.064 0 0 0-5.058 5.058 5.063 5.063 0 0 0 5.058 5.058 5.04 5.04 0 0 0 3.585-1.492 3.25 3.25 0 0 0 2.5 1.492 3.4 3.4 0 0 0 2.3-.67c.603-.458 1.048-1.116 1.292-1.906.038-.125.113-.42.113-.42v-.013a9 9 0 0 0 .213-2.05C22.006 6.489 17.519 2 12.003 2"
                fill="white"
            />
        </g>
    </svg>
));
MailBrandAltSize24Glyph.displayName = 'MailBrandAltSize24Glyph';
